module.exports = __webpack_public_path__ + "img/flex-back-small-vip.00c0a0f5.png";